const Ellipse3 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="781"
      height="297"
      viewBox="0 0 781 297"
      fill="none"
    >
      <g filter="url(#filter0_f_23_51)">
        <ellipse
          cx="379.5"
          cy="207.5"
          rx="301.5"
          ry="107.5"
          fill="url(#paint0_linear_23_51)"
          fill-opacity="0.7"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_23_51"
          x="-22"
          y="0"
          width="803"
          height="415"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="50"
            result="effect1_foregroundBlur_23_51"
          />
        </filter>
        <linearGradient
          id="paint0_linear_23_51"
          x1="379.5"
          y1="100"
          x2="379.5"
          y2="315"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2D061B" />
          <stop offset="1" stop-color="#B9317A" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Ellipse3;
